/**
 * Collection of public properties that are fetched prior to the app initializing.
 * These properties are fetched using the webservice method getPublicProperties()
 * @class
 */
import Base from './labelValues';
import Model from '../models/labelValue';

class PublicProperties extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/**
	 * @property {object} methods       - Collection RPC methods
	 * @property {method} methods.read  - Fetch public properties
	 */
	get methods() {
		return {
			read: ['getPublicProperties'],
		};
	}

	/** @override */
	constructor(models, opts = {}) {
		opts.model = opts.model || Model;
		super(models, opts);
	}

	/** @type {string} */
	static get __name__() {
		return 'PublicProperties';
	}
}

export default PublicProperties;
